'use client'

import { Hero } from '@/components/hero'
import { About } from '@/components/about'
import { ServicesPreview } from '@/components/services-preview'
import { ProjectsHome } from '@/components/projects-home'
import { PricingSection } from '@/components/pricing-section'
import { TestimonialsSection } from '@/components/testimonials-section'
import { ResourcesSection } from '@/components/resources-section'
import { CTASection } from '@/components/cta-section'
import { TechStack } from '@/components/tech-stack'

export default function Home() {
  return (
    <div className="overflow-hidden">
      <Hero />
      <About />
      <ServicesPreview />
      <ProjectsHome />
      <PricingSection />
      <TestimonialsSection />
      <ResourcesSection />
      <TechStack />
      <CTASection />
    </div>
  )
}

